import { Component, HostListener, OnInit } from '@angular/core';
import { AuthRepository } from 'app/state/auth.repository';
import {
  IConfirm,
  tenantSortOptions,
  TenantsRepository,
} from 'app/state/tenants.repository';
import { TenantsService } from 'app/state/tenants.service';
import { TenantsListPageDto } from 'app/api/models/tenant/tenantsListPageDto';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { NotificationService } from 'app/api/services/notificationService';
import { MessageText, ToastService } from 'app/helpers/services/toastService';
import { TrackRender } from 'app/shared/front-perfomance';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@TrackRender()
@Component({
  selector: 'app-tenants-page',
  templateUrl: './tenants-page.component.html',
  styleUrls: ['./tenants-page.component.scss'],
  standalone: false,
})
export class TenantsPageComponent implements OnInit {
  sortOptions = tenantSortOptions;
  innerWidth = 0;
  allTenants: TenantsListPageDto[] = [];
  filteredTenants: TenantsListPageDto[] = [];
  showDailyEmailsButton = false;
  searchQuery = '';
  viewMode: 'list' | 'card' = 'list';

  constructor(
    public repo: TenantsRepository,
    public service: TenantsService,
    public auth: AuthRepository,
    public generalDataRepo: GeneralDataRepository,
    public notificationService: NotificationService,
    public toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.updateTenantsList();
    this.generalDataRepo.allGeneralData$
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        const activeUserEmail = data.activeUserData.email;
        if (
          activeUserEmail == 'aka@a2software.dk' ||
          activeUserEmail == 'pm@a2software.dk'
        ) {
          this.showDailyEmailsButton = true;
        }
      });
  }

  updateTenantsList() {
    this.service
      .getAllTenants()
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        this.allTenants = data;
        this.applyFilter();
        setTimeout(() => {
          console.log('APP_READY_TenantsList');
        }, 2000);
      });
  }

  applyFilter() {
    const query = this.searchQuery.toLowerCase();
    this.filteredTenants = query
      ? this.allTenants.filter((item) =>
          item.name.toLowerCase().includes(query),
        )
      : this.allTenants;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  refreshData() {
    this.updateTenantsList();
  }

  delete(id: string) {
    this.service.delete(id).subscribe(() => {
      this.refreshData();
      this.generalDataRepo.updateAllGeneralData(true);
    });
  }

  handleCloneClick(event: IConfirm) {
    this.service.clone(event.id!, event.title).subscribe(() => {
      this.refreshData();
      this.generalDataRepo.updateAllGeneralData(true);
    });
  }

  sendDailyMails() {
    this.notificationService.sendDailyMails().subscribe((x) => {
      this.toastService.showSuccess(MessageText.success);
    });
  }

  get totalUsers(): number {
    return this.allTenants.reduce((sum, item) => sum + item.countOfUsers, 0);
  }
}
